// extracted by mini-css-extract-plugin
export default {"hint":"TurnoModal_hint__i1-pb","createPatientRow":"TurnoModal_createPatientRow__k3SqX"};